import React, { createContext, useState } from 'react'

const defaultState = {
  toolsOpen: false,
  localizationsCountry: false,
  logOpen: false,
  graphqlOpen: false
}
export const DevToolsContext = createContext(defaultState)

const DevToolsContextProvider = props => {
  const [toolsOpen, setToolsOpen] = useState(false)
  const [localizationsCountry, setLocalizationsCountry] = useState('🇨🇦')
  const [logOpen, setLogOpen] = useState(false)
  const [graphqlOpen, setGraphOpen] = useState(false)

  return (
    <DevToolsContext.Provider value={{
      tools: [toolsOpen, setToolsOpen],
      localizations: [localizationsCountry, setLocalizationsCountry],
      logger: [logOpen, setLogOpen],
      graphql: [graphqlOpen, setGraphOpen]
    }}>
      {props.children}
    </DevToolsContext.Provider>
  )
}

export default DevToolsContextProvider
